import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    Observable,
    BehaviorSubject,
    Subscription,
    combineLatest,
    Subject,
    of,
    zip
} from 'rxjs';
import { LgvModel } from '../../data-models/longevity.model';
import { ActivatedRoute, Router } from '@angular/router';

import {
    ROUTE_ANIMATIONS_ELEMENTS,
    NotificationService,
    LgvAPIService,
    LgvSnapshotHelper,
    LgvClientService,
    LgvTSHelper
} from '../../core/core.module';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '../../../environments/environment';
import {
    filter,
    first,
    map,
    mergeMap,
    take,
    takeUntil,
    takeWhile,
    tap
} from 'rxjs/operators';
import { LgvGridManager } from '../grid-manager/grid-manager';
import { LgvUserService } from '../../core/services/lgv-user.service';
import { EditLoanPopup } from '../../modules/client/controls/edit-loan-popup/edit-loan-popup.component';
import { Modal } from '../modal-form/modal-form-model';

import { ModalFormComponent } from '../modal-form/modal-form.component';
import { CreateLoanComponent } from '../create-loan/create-loan.component';
import { ConfirmEmailInvitationModalComponent } from '../confirm-email-invitation-modal/confirm-email-invitation-modal.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { LgvPublicRecordModel } from '../../data-models/lgv-publicRecord.model';
import { AddPropertyModalComponent } from '../add-property-modal/add-property-modal.component';
import {
    PricingStatus,
    PricingStatusName
} from '../../core/enums/property.enum';
import { EditLoanScenarioModalComponent } from '../edit-loan-scenario-modal/edit-loan-scenario-modal.component';
import { EditClientProfileComponent } from '../edit-client-profile/edit-client-profile.component';
import { ClientLoginLinkModalComponent } from '../../shared/client-login-link-modal/client-login-link-modal.component';
import { StartLoanModalComponent } from '../start-loan-modal/start-loan-modal.component';
import { ViewEmailComponent } from '../../modules/admin/pages/view-email/view-email.component';

@Component({
    selector: 'lgv-client-report',
    templateUrl: './client-report.component.html',
    styleUrls: ['./client-report.component.scss']
})
export class ClientReportComponent implements OnInit, OnDestroy {
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

    _ownedPopertyList: LgvModel.Property[] = [];
    ownedPropertyList$ = new BehaviorSubject(this._ownedPopertyList);

    _prospectPopertyList: LgvModel.Property[] = [];
    prospectPropertyList$ = new BehaviorSubject(this._prospectPopertyList);

    _pricingScenarios: any[] = [];
    pricingScenarios$ = new BehaviorSubject(this._pricingScenarios);

    SelectedPricingScenario: any = null;

    _showingPropertyType = 'Owned';
    showingPropertyType$ = new BehaviorSubject(this._showingPropertyType);

    RadioButton_SelectedProperty: LgvModel.Property = null;

    get ActiveLoansForProperty$(): Observable<LgvModel.Loan[]> {
        return this.LgvClientSvc.SelectedProperty$.pipe(
            map(x => {
                return x === null
                    ? []
                    : this.LgvClientSvc.ActiveLoansForProperty(x);
            })
        );
    }
    get InactiveLoansForProperty$(): Observable<LgvModel.Loan[]> {
        return this.LgvClientSvc.SelectedProperty$.pipe(
            map(x => {
                return x === null
                    ? []
                    : this.LgvClientSvc.InactiveLoansForProperty(x);
            })
        );
    }

    get propertyList$(): Observable<LgvModel.Property[]> {
        return this.showingPropertyType$.value === 'Owned'
            ? this.ownedPropertyList$
            : this.prospectPropertyList$;
    }

    GridMgr: LgvGridManager;
    IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this.IsLoading);
    isProd = env.envName === 'PROD';

    ClientIDParam: string;

    SS$: Observable<LgvModel.ClientSnapshot>;

    AgentSS: LgvModel.AgentSS;

    _Activities: LgvModel.Activity[] = null;
    Activities$ = new BehaviorSubject(this._Activities);

    _ClientGoals: LgvModel.Goal[] = null;
    ClientGoals$ = new BehaviorSubject(this._ClientGoals);

    _CoBrandingPartner: LgvModel.AgentDTO = null;
    CoBrandingPartner$ = new BehaviorSubject(this._CoBrandingPartner);

    ShowPublicRecordData = true;

    environment: string;
    LoanHistory: any = null;

    _PublicRecordSearchList: LgvPublicRecordModel.PublicRecordHistorySearchResult[] = null;
    PublicRecordSearchList$ = new BehaviorSubject(this._PublicRecordSearchList);

    _SelectedPublicRecord: LgvPublicRecordModel.PublicRecord = null;
    SelectedPublicRecord$ = new BehaviorSubject(this._SelectedPublicRecord);

    dialogAttr: Modal;
    seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
    loanHistoryCount: any = null;
    IsCreateLoan: boolean;
    IsCoBranded$ = new BehaviorSubject(false);
    Observable$: Observable<any>;
    onDestroy$ = new Subject();

    constructor(
        private http: HttpClient,
        private notificationSvc: NotificationService,
        private router: Router,
        public LgvAPI: LgvAPIService,
        public LgvUserSvc: LgvUserService,
        public LgvClientSvc: LgvClientService,
        private NotificationSvc: NotificationService,
        public SSHlpr: LgvSnapshotHelper,
        private route: ActivatedRoute,
        public MatDialog: MatDialog,
        private cdr: ChangeDetectorRef
    ) {
        this.GridMgr = new LgvGridManager();
        this.GridMgr.Init('activityTimestamp', 'desc');
        this.environment = env.envName;
        this.dialogAttr = {
            title: '',
            content: null,
            startButtonText: 'SUBMIT',
            endButtonText: 'RETURN',
            startButtonKey: 'SUBMIT',
            endButtonKey: 'CANCEL'
        };
        this.IsCreateLoan = false;
    }

    ngOnInit() {
        this.LgvClientSvc.HaveIncompleteLoanInformation$.next(false);
        this.GridMgr.OnRefreshData.pipe(takeUntil(this.onDestroy$)).subscribe(
            () => {
                this.FetchActivities();
            }
        );
        this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
            this.ClientIDParam = params['id'];
            if (this.ClientIDParam) {
                // Calling page should have already called LoadAgentSS...  Wait for that agent to be loaded in User Service
                this.LgvUserSvc.AgentSS$.pipe(first(f => f !== null)).subscribe(
                    x => {
                        this.AgentSS = x;
                        this.AfterClientIDParamAndAgentSSInit();
                    }
                );
            }
        });
    }

    ngOnDestroy(): void {
        this.LgvClientSvc.HaveIncompleteLoanInformation$.next(false);
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    AfterClientIDParamAndAgentSSInit() {
        //console.log('AfterClientIDParamAndAgentSSInit()');

        this.LgvClientSvc.LoadSnapshotForNonClient(this.ClientIDParam);
        if (
            this.LgvClientSvc.SnapShot$?.value?.clientInfo?.id ===
            this.ClientIDParam
        ) {
            // emit existing values so it would still repopulate
            this.LgvClientSvc['InitFromSnapshot'](
                this.LgvClientSvc.SnapShot$?.value
            );
        }
        this.SS$ = this.LgvClientSvc.SnapShot$;
        //this.ClientLoan$ = this.LgvClientSvc.SelectedClientLoan$;
        this.FetchActivities();
        this.Observable$ = combineLatest([
            this.LgvClientSvc.HaveIncompleteSnapShot$,
            this.LgvClientSvc.PartialSnapShot$
        ]).pipe(map(data => ({ havepartial: data[0], partialss: data[1] })));
        this.Observable$.pipe(
            filter(f => !!f),
            takeUntil(this.onDestroy$)
        ).subscribe(res => {
            if (res.havepartial != false) {
                this.initCoBranding(res.partialss);
            }
        });
        this.SS$.pipe(
            filter(f => f !== null),
            tap(ss => {
                this.initCoBranding(ss);
            }),
            takeUntil(this.onDestroy$)
        ).subscribe(ss => {
            let filteredGoals = ss.goals.filter(x => x.enabled);
            this.ClientGoals$.next(filteredGoals);
        });

        combineLatest([
            this.LgvClientSvc.ClientProperties$.pipe(filter(f => f !== null)),
            this.LgvClientSvc.SelectedProperty$.pipe(
                filter(f => f !== null),
                takeUntil(this.onDestroy$)
            )
        ]).subscribe(([properties, selectedProperty]) => {
            this.populateClientProperties(
                properties,
                selectedProperty,
                this.LgvClientSvc.SnapShot$?.value?.clientInfo?.id !==
                    this.ClientIDParam
            );
        });

        this.LgvClientSvc.SelectedProperty$.pipe(
            takeUntil(this.onDestroy$)
        ).subscribe(p => {
            if (p) {
                if (this.LoanHistory) {
                    let lh = this.LoanHistory.filter(
                        f => f.property.propertyInfo.id === p.propertyInfo.id
                    );
                    this.loanHistoryCount = lh.length;
                }
            }
        });

        this.LgvClientSvc.loadOpportunities();
    }

    populateClientProperties(
        properties,
        selectedProperty,
        shouldRefreshPropertyType = false
    ) {
        // set up radio button lists and initialize selected radio to selectedProperty
        console.log(
            'shouldRefreshPropertyType',
            shouldRefreshPropertyType,
            this.showingPropertyType$?.value
        );
        this.ownedPropertyList$.next(
            properties.filter(f => f.associationType === 'Owned')
        );
        this.prospectPropertyList$.next(
            properties.filter(f => f.associationType === 'Prospect')
        );
        if (shouldRefreshPropertyType) {
            this.showingPropertyType$.next(selectedProperty?.associationType);
        }
        let targetId = selectedProperty?.propertyInfo?.id;

        if (
            this.showingPropertyType$?.value === 'Owned' &&
            this.ownedPropertyList$?.value?.length > 0
        ) {
            let target = this.ownedPropertyList$.value.find(
                x => x.propertyInfo.id === targetId
            );
            this.RadioButton_SelectedProperty = target
                ? target
                : this.ownedPropertyList$.value[0];
        }
        if (
            this.showingPropertyType$?.value === 'Prospect' &&
            this.prospectPropertyList$.value &&
            this.prospectPropertyList$.value.length > 0
        ) {
            let target = this.prospectPropertyList$.value.find(
                x => x.propertyInfo.id === targetId
            );
            this.RadioButton_SelectedProperty = target
                ? target
                : this.prospectPropertyList$.value[0];
        }
        if (!this.showingPropertyType$?.value) {
            this.showingPropertyType$.next('Propertyless');
        }
    }

    togglePropertyList(propertyType: string) {
        let newProp = null;
        switch (propertyType) {
            case 'Owned':
                if (
                    this.ownedPropertyList$.value &&
                    this.ownedPropertyList$.value.length > 0
                ) {
                    this.showingPropertyType$.next('Owned');
                    newProp = this.ownedPropertyList$.value[0];
                }
                break;
            case 'Prospect':
                if (
                    this.prospectPropertyList$.value &&
                    this.prospectPropertyList$.value.length > 0
                ) {
                    this.showingPropertyType$.next('Prospect');
                    newProp = this.prospectPropertyList$.value[0];
                }
                break;
            case 'Propertyless':
                this.showingPropertyType$.next('Propertyless');
                this.LgvClientSvc.SetSelectedProperty(null);
                break;
            default:
        }

        if (newProp) {
            this.RadioButton_SelectedProperty = newProp;
            this.LgvClientSvc.SetSelectedProperty(newProp);
        }
    }

    FetchActivities() {
        this.IsLoading = true;

        let bldUrl = `${env.LgvApiBaseUrl}/clients/${this.ClientIDParam}/activities?x=y${this.GridMgr.ODataSuffix}`;

        this.http
            .get<any>(bldUrl)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(
                x => {
                    this.Activities$.next(x.value);
                    this.GridMgr.SetTotalResultSize(x['count']);
                    this.IsLoading = false;
                },
                () => {
                    this.IsLoading = false;
                }
            );
    }

    OnGoToClientView(agentID: string) {
        this.LgvUserSvc.ImpersonateAgent(agentID);
        this.LgvClientSvc.navigateToHomePage(this.ClientIDParam);
    }

    OnGoToPriceThisClient() {
        let url = `/#/admin/pricing-search/${this.ClientIDParam}`;
        window.open(url, '_blank');
    }

    OpenEditLoanDialog(loan: LgvModel.Loan) {
        const dialogRef = this.MatDialog.open(EditLoanPopup, {
            width: '500px',
            data: {
                client: this.ClientIDParam,
                isFirstLoan: true,
                loan
            }
        });
    }

    openDialog(data: Modal, component, size) {
        return this.MatDialog.open(component, {
            width: size,
            panelClass: 'dialog-container',
            disableClose: true,
            data
        });
    }

    OnSelectedPropertyChanged() {
        //console.log('OnSelectedPropertyChanged:');
        //this.LgvClientSvc.SetSelectedProperty(this.RadioButton_SelectedProperty);
        if (this.RadioButton_SelectedProperty.associationType === 'Owned') {
            this.LgvClientSvc.SetSelectedClientPropertyAndLoan(
                this.RadioButton_SelectedProperty,
                null
            );
        } else {
            this.LgvClientSvc.setSelectedClientPropertyAndLoanScenario(
                this.RadioButton_SelectedProperty,
                this.RadioButton_SelectedProperty?.loanScenarios[0]
            );
        }
    }

    OnGoToCreateLoan(property: LgvModel.Property) {
        this.LgvClientSvc.SetSelectedProperty(property);
        this.dialogAttr.title = 'Please enter your loan information';
        this.dialogAttr.component = CreateLoanComponent;
        this.openDialog(this.dialogAttr, ModalFormComponent, '550px');
    }

    OnBack(event) {
        //console.log(event)
        this.IsCreateLoan = event;
    }

    SendClientInvitation(clientId: string) {
        this.dialogAttr.title = 'Send Client Invitation';
        this.dialogAttr.content = { clientId: clientId };
        this.openDialog(
            this.dialogAttr,
            ConfirmEmailInvitationModalComponent,
            '350px'
        );
    }

    onGenerateClientToken(clientId: string, makeExpired = false) {
        this.dialogAttr.title = 'Send Client Invitation';
        this.dialogAttr.content = {
            clientId: clientId,
            makeExpired: makeExpired
        };
        this.openDialog(
            this.dialogAttr,
            ClientLoginLinkModalComponent,
            '350px'
        );
    }

    /****@initCoBranding void method
     **Initiate co-branded realestate agent for admin view when impersonate the agent
     ****/
    initCoBranding(pss): void {
        // if the selected agent (LgvUserSvc.AgentID) != the owning agent, then retrieve the cobranding agent info from the service
        if (pss?.clientInfo?.ownerId !== this.LgvUserSvc.AgentID) {
            // make sure partners have finished loading...
            this.LgvUserSvc.CobrandedRealEstatePartners$.pipe(
                first(f => f !== null)
            ).subscribe(() => {
                let coBrandingPartner = this.LgvUserSvc.GetCoBrandedRealEstatePartnerByID(
                    pss.clientInfo.ownerId
                );
                this.CoBrandingPartner$.next(coBrandingPartner);
            });
        }
    }

    OnConfirmSilenceClient(client: LgvModel.ClientInfo, bSilence: boolean) {
        const dialogRef = this.MatDialog.open(ConfirmationDialogComponent, {
            width: '250px',
            data: {
                Confirmation: `Are you sure you want to ${
                    bSilence ? 'stop' : 'enable'
                } all communication with <b>${client.firstName} ${
                    client.lastName
                }</b>?`
            }
        });

        dialogRef.afterClosed().subscribe(x => {
            if (x.action == true) {
                this.LgvClientSvc.SilenceThisClient(client.id, bSilence)
                    .pipe(takeUntil(this.onDestroy$))
                    .subscribe(
                        x => {
                            if (bSilence) {
                                this.NotificationSvc.success(
                                    `Communication with ${client.firstName} ${client.lastName} will be terminated.`
                                );
                            } else {
                                this.NotificationSvc.success(
                                    `Communication with ${client.firstName} ${client.lastName} has been enabled.`
                                );
                            }

                            // Refresh snapshot
                            this.LgvClientSvc.LoadSnapshotForNonClient(
                                this.ClientIDParam,
                                false,
                                true
                            );
                        },
                        err => {
                            this.NotificationSvc.error(
                                `There was an error trying to ${
                                    bSilence ? 'silence' : 'enable'
                                } ${client.firstName} ${client.lastName}.`
                            );
                        }
                    );
            }
        });
    }

    onOpenAddPropertyModal() {
        const dialogRef = this.MatDialog.open(AddPropertyModalComponent, {
            width: '800px',
            panelClass: 'dialog-container',
            disableClose: true,
            data: {
                clientId: this.ClientIDParam,
                name:
                    this.LgvClientSvc.SnapShot$.value?.clientInfo?.firstName +
                    ' ' +
                    this.LgvClientSvc.SnapShot$.value?.clientInfo?.lastName,
                showPrimaryPropertyToggle: true
            }
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(x => {
                if (x.action === true) {
                    // Refresh snapshot
                    this.LgvClientSvc.LoadSnapshotForNonClient(
                        this.ClientIDParam,
                        false,
                        true
                    );
                }
            });
    }

    onEditContactInformation(clientInfo: LgvModel.ClientInfo) {
        this.onOpenEditClientProfileModal(clientInfo, 'EditContactInformation');
    }

    onEditFinancialDetails(clientInfo: LgvModel.ClientInfo) {
        this.onOpenEditClientProfileModal(clientInfo, 'EditFinancialDetails');
    }

    onOpenEditClientProfileModal(
        clientInfo: LgvModel.ClientInfo,
        mode: string
    ) {
        const dialogRef = this.MatDialog.open(EditClientProfileComponent, {
            width: '600px',
            panelClass: 'dialog-container',
            disableClose: true,
            data: {
                clientInfo: clientInfo,
                pageMode: mode,
                needRefresh: true
            }
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(x => {
                if (x.action === true) {
                    // Refresh snapshot
                    this.LgvClientSvc.LoadSnapshotForNonClient(
                        this.ClientIDParam,
                        false,
                        true
                    );
                }
            });
    }

    onLoadLoanSenarioOpportunities(
        property: LgvModel.Property,
        loanOrScenarioID: string
    ) {
        //    console.log('onLoadLoanSenarioOpportunities() =======================');
        //    const isOwned = property.associationType === 'Owned';
        //    this.LgvClientSvc.LoadOpportunitiesForLoanOrLoanScenario(
        //        this.ClientIDParam,
        //        isOwned ? loanOrScenarioID : null,
        //        isOwned ? null : loanOrScenarioID,
        //        true);
    }

    onEditLoanScenario(event: any) {
        const clientId = this.LgvClientSvc.ClientID$.value;
        const dialogRef = this.MatDialog.open(EditLoanScenarioModalComponent, {
            width: '800px',
            panelClass: 'dialog-container',
            disableClose: true,
            data: {
                clientId: clientId,
                propertyId: event.propertyId,
                lScenario: event.lScenario
            }
        });

        dialogRef
            .afterClosed()
            .pipe(first())
            .subscribe(x => {
                if (x.action === true) {
                    // Refresh snapshot
                    this.LgvClientSvc.LoadSnapshotForNonClient(
                        clientId,
                        false,
                        true
                    );
                }
            });
    }

    onStartLoanFile() {
        // if logged in as admin, user value should be the client's user, not the logged in user.
        if (this.LgvUserSvc.IsAnyAdmin) {
            this.LgvUserSvc.LoadAgentSS(
                this.LgvClientSvc.SnapShot$.value?.clientInfo?.ownerId
            );
        }
        this.LgvUserSvc.AgentDTO$.pipe(
            filter(
                f =>
                    f !== null &&
                    f.agentInfo.id ===
                        this.LgvClientSvc.SnapShot$.value?.clientInfo?.ownerId
            ),
            take(1)
        ).subscribe(agent => {
            const dialogRef = this.MatDialog.open(StartLoanModalComponent, {
                width: '700px',
                //height: '700px',
                panelClass: 'dialog-container',
                //disableClose: true,
                data: {
                    agentDTO: agent,
                    isClientMode: true
                }
            });

            dialogRef
                .afterClosed()
                .pipe(first())
                .subscribe(x => {
                    if (x.action === true) {
                        // Refresh snapshot
                        //this.LgvClientSvc.LoadSnapshotForNonClient(clientId, false, true);
                    }
                });
        });
    }

    onViewClientEmails() {
        let url = `/#/admin/view-email/client/${this.ClientIDParam}`;
        window.open(url, '_blank');
    }

    onEmailClient() {
        this.LgvUserSvc.UserHasMailBox$.pipe(take(1)).subscribe(hasMB => {
            if (hasMB) {
                ViewEmailComponent.sendClientEmailInApp(this.ClientIDParam);
            } else {
                ViewEmailComponent.sendEmailInApp(
                    this.LgvClientSvc.SnapShot$.value?.clientInfo?.email,
                    false
                );
            }
        });
    }
}
